import axios from 'axios';

import { parseSuccess } from '@/api/request';

import requestInterceptors from './request_interceptors';
import responseInterceptors from './response_interceptors';

const api = {
  configure: (options) => {
    axios.defaults.baseURL = options.baseUrl;
    axios.defaults.headers.common = options.defaultHeaders || {};
  },
};
// axios.defaults.headers.common = options.defaultHeaders || {};
// Setup interceptors
axios.interceptors.request.use((config) => {
  requestInterceptors.forEach(callback => callback(config));

  return config;
}, error => (
  Promise.reject(error)
));

axios.interceptors.response.use((response) => {
  responseInterceptors.forEach(callback => callback(response));

  return parseSuccess(response);
}, (error) => {
  responseInterceptors.forEach(callback => callback(error.response));

  return Promise.reject(error);
});

export default api;



// WEBPACK FOOTER //
// ./src/api/index.js